/**
 * Source Badge Component - The Intelligent Standard
 *
 * A badge for displaying prompt source (seed vs arena)
 * with appropriate semantic coloring.
 */

export type PromptSource = 'seed' | 'arena';

export interface SourceBadgeProps {
  source: PromptSource;
  size?: 'sm' | 'md';
}

const sizeStyles = {
  sm: {
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '0.6875rem',
  },
  md: {
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '0.75rem',
  },
};

const sourceStyles = {
  seed: {
    background: '#E8F5E9',
    color: '#2E7D4A',
  },
  arena: {
    background: '#E3F2FD',
    color: '#1565C0',
  },
};

export function SourceBadge({ source, size = 'md' }: SourceBadgeProps) {
  const sizeStyle = sizeStyles[size];
  const sourceStyle = sourceStyles[source];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.025em',
        ...sizeStyle,
        ...sourceStyle,
      }}
    >
      {source}
    </span>
  );
}
